import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TemplateTabLayout } from '../TemplateTabLayout';
import { TemplatesList } from './TemplatesList';
import { TemplateFormDialog } from './TemplateFormDialog';
import type { ChecklistTemplate } from '@/hooks/useChecklists';

export function ChecklistTemplatesTab() {
  const { t } = useTranslation('checklists');
  const [editTemplate, setEditTemplate] = useState<ChecklistTemplate | null>(null);

  return (
    <TemplateTabLayout
      title={t('template.title')}
      subtitle={t('template.subtitle')}
      createLabel={t('template.create')}
      showInactiveLabel={t('template.showInactive')}
      isEditing={editTemplate !== null}
      onCloseDialog={() => setEditTemplate(null)}
      renderList={(includeInactive) => (
        <TemplatesList onEdit={setEditTemplate} includeInactive={includeInactive} />
      )}
      renderDialog={(open, onClose) => (
        <TemplateFormDialog open={open} onClose={onClose} template={editTemplate} />
      )}
    />
  );
}
